import { LayoutNode } from './layout-node';
import * as d3 from 'd3';

export class NodeGroup extends LayoutNode {
    public children: NodeGroup[];
    public margin: number = 0.2;
    public minimumPixelMargin: number = 0;

    constructor() {
        super();
    }

    public addChild(c: NodeGroup) {
        this.children.push(c);
        c.parent = this;
    }

    public calculateLayoutRecursive() {
        if (this.children.length > 0) {
            d3.packSiblings(this.children);
            this.children.forEach(childNode => {
                childNode.calculateLayoutRecursive();
            });
        }
    }

    public normalizeLayoutRecursive() {
        if (this.children.length > 0) {
            const enclosure = d3.packEnclose(this.children);
            const scaleFactor = enclosure.r * 2;

            this.children.forEach(childNode => {
                childNode.r = childNode.r / scaleFactor;
                childNode.x = childNode.x / scaleFactor;
                childNode.y = childNode.y / scaleFactor;
            });
            this.children.forEach(childNode => {
                childNode.normalizeLayoutRecursive();
            });
        }
    }

    public isLeaf() {
        return false;
    }

    public isRoot() {
        return false;
    }

    public setRadii() {
        this.r = Math.sqrt(this.children.length + 1);

        this.children.forEach(childNode => {
            childNode.setRadii();
        });
    }

    public calculatePixelPositionsRecursive() {
        if (this.parent.children.length === 1) {
            this.pixelR = this.parent.pixelR * 1.2 * this.r;
        } else {
            this.pixelR = this.parent.pixelR * 2 * this.r;
        }

        if (this.children.length === 0) {
            this.pixelR = this.pixelR - Math.max(this.minimumPixelMargin, (this.pixelR * this.margin) / 4);
        } else {
            this.pixelR = this.pixelR - Math.max(this.minimumPixelMargin, this.pixelR * this.margin);
        }
        this.pixelX = this.parent.pixelR * 2 * this.x + this.parent.pixelX;
        this.pixelY = this.parent.pixelR * 2 * this.y + this.parent.pixelY;
        this.positionUpdated.post();

        this.children.forEach(child => {
            child.calculatePixelPositionsRecursive();
        });
    }
}
